import { Action } from '@ngrx/store';
import { Tracking } from '../_models/tracking';

export enum AppActitonTypes {
	ChangeAlertModal = '[App] Change AlertModal',
	ChangeInfoModal = '[App] Change InfoModal',
	ChangeLoading = '[App] Change Loading',
	ChangeLoading1 = '[App] Change Loading 1',
	ChangeLoading2 = '[App] Change Loading 2',
	ChangeLoading3 = '[App] Change Loading 3',
	ChangeLoading4 = '[App] Change Loading 4',
	ChangeLoading5 = '[App] Change Loading 5',
	ChangeLoading6 = '[App] Change Loading 6',
	RegisterTracking = '[App] Register Tracking',
	RegisterTrackingSuccess = '[App] Register Tracking Success',
	RegisterTrackingFail = '[App] Register TrackingFail'
}

export class ChangeAlertModal implements Action {
	readonly type = AppActitonTypes.ChangeAlertModal;

	constructor(public payload: { value: boolean, info: string }) {}
}

export class ChangeInfoModal implements Action {
	readonly type = AppActitonTypes.ChangeInfoModal;

	constructor(public payload: { value: boolean, info: string, link: string, param: any, skin: string }) {}
}

export class ChangeLoading implements Action {
	readonly type = AppActitonTypes.ChangeLoading;

	constructor(public payload: boolean) {}
}

export class ChangeLoading1 implements Action {
	readonly type = AppActitonTypes.ChangeLoading1;

	constructor(public payload: boolean) {}
}

export class ChangeLoading2 implements Action {
	readonly type = AppActitonTypes.ChangeLoading2;

	constructor(public payload: boolean) {}
}

export class ChangeLoading3 implements Action {
	readonly type = AppActitonTypes.ChangeLoading3;

	constructor(public payload: boolean) {}
}

export class ChangeLoading4 implements Action {
	readonly type = AppActitonTypes.ChangeLoading4;

	constructor(public payload: boolean) {}
}

export class ChangeLoading5 implements Action {
	readonly type = AppActitonTypes.ChangeLoading5;

	constructor(public payload: boolean) {}
}

export class ChangeLoading6 implements Action {
	readonly type = AppActitonTypes.ChangeLoading6;

	constructor(public payload: boolean) {}
}

export class RegisterTracking implements Action {
	readonly type = AppActitonTypes.RegisterTracking;

	constructor(public payload: Tracking) {}
}

export class RegisterTrackingSuccess implements Action {
	readonly type = AppActitonTypes.RegisterTrackingSuccess;

	constructor(public payload: Tracking) {}
}

export class RegisterTrackingFail implements Action {
	readonly type = AppActitonTypes.RegisterTrackingFail;

	constructor(public payload: string) {}
}

// Unión de acciones
export type AppActions = ChangeAlertModal
| ChangeInfoModal
| ChangeLoading
| ChangeLoading1
| ChangeLoading2
| ChangeLoading3
| ChangeLoading4
| ChangeLoading5
| ChangeLoading6
| RegisterTracking
| RegisterTrackingSuccess
| RegisterTrackingFail;